// useWindowWidth.js
import { ref, onMounted, onUnmounted, computed } from 'vue';

export function useWindowWidth(breakpoint = 1000) {
  const width = ref(window.innerWidth);

  const onResize = () => {
    width.value = window.innerWidth;
  };

  onMounted(() => window.addEventListener('resize', onResize));
  onUnmounted(() => window.removeEventListener('resize', onResize));

  const isSmall = computed(() => width.value < breakpoint);

  return { width, isSmall };
}
